<app-search-bar
  (searchTermChanged)="searchTermChanged($event)"
  [placeholder]="'bank_choice_search' | translate"
></app-search-bar>

@if (searchTerm === undefined || searchTerm.trim() === '') {
  <app-bank [banks]="topBanks"></app-bank>
  <p class="font-bold text-secondary mt-10 mb-7">{{ 'other_banks' | translate }}</p>
  <app-bank [banks]="otherBanks"></app-bank>
} @else {
  <app-bank [banks]="filteredBanks"></app-bank>
}
